import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

interface CountdownProps {
  endTime: string; // ISO
}

const Countdown: React.FC<CountdownProps> = ({ endTime }) => {
  const [diff, setDiff] = useState(getDiff(endTime));
  const duration = dayjs.duration(diff);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDiff(getDiff(endTime));
    }, 1000);

    return () => clearTimeout(timeout);
  }, [diff, endTime]);

  const timeIsUp = diff <= 0;

  return timeIsUp ? (
    <p
      className={'font-semibold uppercase'}
      style={{ color: 'var(--color-error)' }}
    >
      Starting Soon!
    </p>
  ) : (
    <div data-testid={'countdown'} className={'flex'}>
      <div className={'mr-5'} data-testid={'countdown-day'}>
        <TimeBox
          // Need the days here, even if they add up to over a month
          numString={duration.asDays().toFixed(0).toString()}
          title={'Day'}
        />
      </div>
      <TimeBox numString={duration.format('HH')} title={'Hour'} />
      <span
        className={'text-4xl ml-2 mr-1 text-gray-400'}
        style={{ letterSpacing: '0.5rem' }}
      >
        :
      </span>
      <TimeBox numString={duration.format('mm')} title={'Minute'} />
      <span
        className={'text-4xl ml-2 mr-1 text-gray-400'}
        style={{ letterSpacing: '0.5rem' }}
      >
        :
      </span>
      <TimeBox numString={duration.format('ss')} title={'Second'} />
    </div>
  );
};

export { Countdown };

// PRIVATE

const getDiff = (endTime: string) => {
  const nowDay = dayjs(Date.now());
  const endDay = dayjs(endTime);
  return endDay.diff(nowDay);
};

const TimeBox: React.FC<{ numString: string; title: string }> = ({
  numString,
  title,
}) => {
  return (
    <div className={'flex flex-col items-center'}>
      <div
        className={'countdown-number text-4xl relative left-1'}
        style={{ letterSpacing: '0.5rem' }}
      >
        {numString}
      </div>
      <div className={'text-sm text-gray-600 mt-2'}>
        {maybePlural(parseInt(numString), title)}
      </div>
    </div>
  );
};

const maybePlural = (num: number, title: string): string => {
  return title + (num === 1 ? '' : 's');
};
